export default "__VITE_ASSET__Ccz81S5z__"